import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import type { ItemDTO } from '@central/types';
import { api } from '@/lib/api';

interface FavoritesResponse {
  items: ItemDTO[];
  total: number;
}

export function useFavorites(): UseQueryResult<FavoritesResponse> {
  return useQuery({
    queryKey: ['favorites'],
    queryFn: () => api<FavoritesResponse>('/api/favorites'),
  });
}

export function useFavoriteIds(): UseQueryResult<{ ids: number[] }> {
  return useQuery({
    queryKey: ['favorites', 'ids'],
    queryFn: () => api<{ ids: number[] }>('/api/favorites/ids'),
  });
}

export function useToggleFavorite(): ReturnType<
  typeof useMutation<void, Error, { itemId: number; isFavorited: boolean }>
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ itemId, isFavorited }) => {
      if (isFavorited) {
        await api(`/api/favorites/${itemId}`, { method: 'DELETE' });
      } else {
        await api('/api/favorites', { method: 'POST', body: { item_id: itemId } });
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['favorites'] });
    },
  });
}
